var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12H13ZM11 16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5H11ZM11 8.66455C11 9.21684 11.4477 9.66455 12 9.66455C12.5523 9.66455 13 9.21684 13 8.66455H11ZM13 8.625C13 8.07272 12.5523 7.625 12 7.625C11.4477 7.625 11 8.07272 11 8.625H13ZM11 12L11 16.5H13L13 12H11ZM13 8.66455V8.625H11V8.66455H13ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12L4 12ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM20 12C20 16.4183 16.4183 20 12 20L12 22C17.5228 22 22 17.5228 22 12H20ZM12 20C7.58172 20 4 16.4183 4 12L2 12C2 17.5228 6.47715 22 12 22L12 20Z",
    fill: "#adaaaa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltipIcon);
export default __webpack_public_path__ + "static/media/info-tooltip-icon.8d2d7fde6cbce496b7d79e792f58c840.svg";
export { ForwardRef as ReactComponent };